import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { genericApi } from '~/api'
import { logout } from '~/store/auth/slice'
import { AUTH_TOKEN } from '~/utils/constants'
import { showErrors } from '~/utils/helpers'

export const useLogoutMutation = () => {
  const dispatch = useDispatch()
  return useMutation(genericApi.logout, {
    onSuccess: () => {
      dispatch(logout())
      localStorage.removeItem(AUTH_TOKEN)
    },
    onError: showErrors
  })
}
